import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ServiceApiService } from '../../Services/service-api.service';
import { BookingService } from '../services/booking.service';
import { InvoiceService } from '../services/invoice.service';
import { Service } from '../../objects/service';
import { Booking } from '../../objects/booking';
import { User } from '../../objects/user';

@Component({
  selector: 'app-provider-dashboard',
  templateUrl: './provider-dashboard.component.html',
  styleUrls: ['./provider-dashboard.component.css']
})
export class ProviderDashboardComponent implements OnInit {
  provider!: User;
  services: Service[] = [];
  bookings: Booking[] = [];
  isLoadingServices = true;
  isLoadingBookings = true;
  invoicingBookingId: string | null = null;
  invoiceError = '';

  constructor(
    private authService: AuthService,
    private serviceApi: ServiceApiService,
    private bookingService: BookingService,
    private invoiceService: InvoiceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.provider = this.authService.getCurrentUser();
    if (!this.provider) {
      this.router.navigate(['/auth']);
      return;
    }
    this.loadServices();
    this.loadBookings();
  }

  loadServices(): void {
    this.isLoadingServices = true;
    this.serviceApi.getByProvider(this.provider!.id).subscribe({
      next: (data) => {
        this.services = data;
        this.isLoadingServices = false;
      },
      error: () => {
        this.services = [];
        this.isLoadingServices = false;
      }
    });
  }

  loadBookings(): void {
    this.isLoadingBookings = true;
    this.bookingService.getBookings(String(this.provider!.id), 'provider').subscribe({
      next: (data) => {
        this.bookings = data;
        this.isLoadingBookings = false;
      },
      error: () => {
        this.bookings = [];
        this.isLoadingBookings = false;
      }
    });
  }

  canInvoice(booking: Booking): boolean {
    return booking.status === 'completed' && !booking.stripeInvoiceId;
  }

  sendInvoice(booking: Booking): void {
    this.invoicingBookingId = booking.id;
    this.invoiceError = '';
    this.invoiceService.sendInvoiceForBooking(booking.id).subscribe({
      next: (result) => {
        this.invoicingBookingId = null;
        booking.stripeInvoiceId = result.invoiceId;
        booking.invoiceStatus = result.status;
      },
      error: (err) => {
        this.invoicingBookingId = null;
        this.invoiceError = err?.error?.message || 'Could not send invoice. Please try again.';
      }
    });
  }

  get tradeLabel(): string {
    return (this.provider as any)?.jobTitle || 'Service Provider';
  }

  get serviceAreaDisplay(): string {
    const area = (this.provider as any)?.serviceArea;
    if (Array.isArray(area)) return area.join(', ');
    return area || '—';
  }

  get providerInitials(): string {
    const first = this.provider?.firstName?.[0] || '';
    const last = this.provider?.lastName?.[0] || '';
    return (first + last).toUpperCase() || this.provider?.username?.[0]?.toUpperCase() || '?';
  }

  goToManageServices(): void {
    this.router.navigate(['/provider-services']);
  }
}
